// redux/slices/holidaysSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { resetStore } from "./resetStore";
import { clearJwtToken } from "../../Utils/authStorage";
import { apiRequest } from "../../Utils/apiClient";

/* ========================= Thunks (PRIVATE, с JWT через apiRequest) ========================= */

export const fetchHolidays = createAsyncThunk(
    "holidays/fetchHolidays",
    async ({ uid, year }, { rejectWithValue }) => {
        try {
            if (!uid) throw new Error("UID не передан");

            const y = year || new Date().getFullYear();

            const response = await apiRequest(
                "GET",
                `/holidays?uid=${encodeURIComponent(uid)}&year=${encodeURIComponent(y)}`
            );

            const data = response?.data || {};
            const items = Array.isArray(data.items) ? data.items : [];

            return items;
        } catch (error) {
            const status = error?.response?.status;
            if (status === 401 || status === 403) {
                try {
                    await clearJwtToken();
                } catch { }
            }

            return rejectWithValue(
                error?.response?.data ||
                error?.message ||
                "Fetch holidays failed"
            );
        }
    }
);

/* ========================= Slice ========================= */

const initialState = {
    items: [],
    status: "idle",
    error: null,
};

const holidaysSlice = createSlice({
    name: "holidays",
    initialState,
    reducers: {
        clearHolidays: (state) => {
            state.items = [];
            state.status = "idle";
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchHolidays.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(fetchHolidays.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.items = Array.isArray(action.payload) ? action.payload : [];
            })
            .addCase(fetchHolidays.rejected, (state, action) => {
                state.status = "failed";
                state.error =
                    action.payload || action.error?.message || "Fetch holidays failed";
            })
            .addCase(resetStore, (state) => {
                state.items = [];
                state.status = "idle";
                state.error = null;
            });
    },
});

/* ========================= Selectors ========================= */

const EMPTY_ARR = Object.freeze([]);

export const selectHolidays = (state) => state.holidays?.items ?? EMPTY_ARR;
export const selectHolidaysStatus = (state) => state.holidays?.status || "idle";
export const selectHolidaysError = (state) => state.holidays?.error || null;

/* ========================= Exports ========================= */

export const { clearHolidays } = holidaysSlice.actions;
export default holidaysSlice.reducer;